<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ selectedOperationResult.title | translate }}
            </h1>

            <p class="subtitle-m">
                {{ selectedOperationResult.subtitle | translate }}
            </p>
        </div>

        <form class="form" *ngIf="numeroOperacion" [formGroup]="formGroup">
            <div class="form-row">
                <div class="reference-box">
                    <label for="" class="reference-number">Nº de referencia: {{numeroOperacion}}</label>
                </div>
            </div>
        </form>

        <!-- <div class="actions">
            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div> -->
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
